var _path, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNjoyToastIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 0H5C2.23858 0 0 2.23857 0 4.99999V31.9997C0 34.7611 2.23858 36.9997 5 36.9997H32C34.7614 36.9997 37 34.7611 37 31.9997V5C37 2.23858 34.7614 0 32 0Z",
    fill: "url(#paint0_linear_21205_13140)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5528 23.8395C13.6778 23.8395 9.71173 19.8734 9.71173 14.9985C9.71173 10.1235 13.6778 6.15747 18.5528 6.15747C23.4278 6.15747 27.3939 10.1235 27.3939 14.9985C27.3939 19.8734 23.4278 23.8395 18.5528 23.8395ZM18.5528 9.83669C15.7067 9.83669 13.391 12.1523 13.391 14.9985C13.391 17.8446 15.7067 20.1603 18.5528 20.1603C21.399 20.1603 23.7146 17.8446 23.7146 14.9985C23.7146 12.1523 21.399 9.83669 18.5528 9.83669Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5019 30.2135C14.9255 30.2135 11.5577 28.8264 9.01874 26.3078L11.6097 23.6959C13.4549 25.5264 15.9026 26.5343 18.5019 26.5343C21.1013 26.5343 23.6248 25.4958 25.4799 23.6099L28.1027 26.1899C25.5508 28.7843 22.1408 30.2135 18.5019 30.2135Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5528 17.1056C19.7163 17.1056 20.6596 16.1624 20.6596 14.9989C20.6596 13.8353 19.7163 12.8921 18.5528 12.8921C17.3892 12.8921 16.446 13.8353 16.446 14.9989C16.446 16.1624 17.3892 17.1056 18.5528 17.1056Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_21205_13140",
    x1: 36.6926,
    y1: 0.307405,
    x2: 1.61545,
    y2: 35.3848,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC55FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0045E9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNjoyToastIcon);
export default __webpack_public_path__ + "static/media/njoy-toast-icon.fe842864d7a4ee79e9a5eb1107fa5b04.svg";
export { ForwardRef as ReactComponent };